import { FormActions } from '@openx/components-core/lib/FormActions/FormActions';
import type { LalSegmentFormState } from '@openx/types/segments';
import type { JSX } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSegmentContext } from '../../utils/context/SegmentContext';
import { DetailsSection } from './DetailsSection';
import { OnBehalfOfForm } from './OnBehalfOfForm';
import { Seeds } from './Seeds';

type LalSegmentsFormSectionsProps = {
  goBack: () => void;
  setSelectedAccountId?: (id: string) => void;
  isEdit?: boolean;
  isSubmitting: boolean;
};

export const LalSegmentsFormSections = ({
  isSubmitting,
  goBack,
  isEdit = false,
  setSelectedAccountId,
}: LalSegmentsFormSectionsProps): JSX.Element => {
  const { t } = useTranslation();
  const { useLalSegmentPermissions } = useSegmentContext();
  const { shouldSeeOnBehalfOf } = useLalSegmentPermissions();

  const {
    formState: { isDirty },
  } = useFormContext<LalSegmentFormState>();

  const areFormActionsDisabled = isSubmitting || (isEdit && !isDirty);

  return (
    <>
      {shouldSeeOnBehalfOf && <OnBehalfOfForm isEdit={isEdit} setSelectedAccountId={setSelectedAccountId} />}

      <DetailsSection />
      <Seeds isEdit={isEdit} />
      <FormActions
        submitButtonLabel={t('Save')}
        cancelButtonLabel={t('Cancel')}
        onCancel={goBack}
        disabled={areFormActionsDisabled}
        isSubmitting={isSubmitting}
      />
    </>
  );
};
